import {
  VStack,
  Text,
  Box,
  useColorModeValue,
  Heading,
  HStack,
  useColorMode,
} from "@chakra-ui/react";

const ScheduleDay = ({ day }) => {
  const dayTitleColor = useColorModeValue("#666666", "darkgray");
  const eventTitleColor = useColorModeValue("#444444", "#DDDDDD");
  const textColor = useColorModeValue("#555555", "darkgray");
  const colorMode = useColorMode().colorMode;

  console.log(colorMode);

  function getEventTitleColor(title) {
    if (title.includes("Flight")) {
      return colorMode === "light" ? "#1E90FF" : "#1E90FF"; // Light Blue to Slate Gray
    }
    if (
      title.includes("Lunch") ||
      title.includes("Dinner") ||
      title.includes("snack")
    ) {
      return colorMode === "light" ? "#FF076A" : "#DA3367"; // Light Blue to Slate Gray
    }
    if (title.includes("Matcha")) {
      return colorMode === "light" ? "#3EB489" : "#2E7D32"; // Light Green to Dark Green
    }
    if (title.includes("Coffee")) {
      return colorMode === "light" ? "#A0522D" : "#A0522D"; // Sienna to Saddle Brown
    }
    if (
      title.includes("Resort") ||
      title.includes("Paradise Point") ||
      title.includes("Poolside")
    ) {
      return colorMode === "light" ? "#FF850F" : "#FFA500"; // Gold to Orange
    }
    if (title.includes("Conference")) {
      return colorMode === "light" ? "#3739FF" : "#1E90FF"; // Purple to Indigo
    }
    if (title.includes("Explore")) {
      return colorMode === "light" ? "#1A8478" : "#1A8478"; // Aqua to Blue Violet
    }
    if (title.includes("Brewery")) {
      return colorMode === "light" ? "#F19872" : "#F19872"; // Aqua to Blue Violet
    } else {
      return eventTitleColor;
    }
  }

  return (
    <VStack
      className="scrollable-element"
      align="start"
      spacing="20px"
      minW="100%"
      px="50px"
      fontFamily="Lilita One"
      textColor={textColor}
      fontSize="xl"
      overflow="scroll"
    >
      <HStack minW="100%" justify="space-between">
        <Heading
          fontSize="2xl"
          // color={dayTitleColor}
          color="white"
          textAlign="center"
          fontFamily="Lobster Two"
        >
          {day.subject}
        </Heading>
        <Heading
          fontSize="2xl"
          color={dayTitleColor}
          textAlign="center"
          fontFamily="Lobster Two"
        >
          May {day.day.split("/")[1]}
        </Heading>
      </HStack>

      {day.events.map((event, index) => (
        <Box key={index}>
          <Text textColor={getEventTitleColor(event.title)}>{event.title}</Text>
          <VStack spacing="4px" align="start" ml="12px" fontSize="md">
            {event.notes.map((note, noteIndex) => (
              <Text key={noteIndex}>{note}</Text>
            ))}
          </VStack>
        </Box>
      ))}
    </VStack>
  );
};

export default ScheduleDay;
